import React, { useState, useRef, useEffect } from 'react'

import { connect } from 'react-redux'
import InputStandard from 'components/input/standard'
import Icon from 'components/icon/icon'

import { searchChat } from 'state/actions'

const DockChatSearch = ({
    setSearchResult,
    activeSearchResult,
    chat,
    searchChat,
    visible,
    toggleSearch
}) => {
    const [value, setValue] = useState('')

    const chatRef = useRef(chat)
    chatRef.current = chat

    const inputRef = useRef()

    const handleSearch = () => {
        searchChat(chat.id, value, () => {
            if (chatRef.current.search_results.length) {
                setSearchResult(0)
            }
        })
    }

    useEffect(() => {
        if (visible) {
            if (inputRef.current) {
                inputRef.current.focus()
            }
        }
    }, [visible])

    const options = [
        {
            icon: 'angle-down',
            disableIfNoResults: true,
            onClick: () => {
                let nextSearchResultId = 0

                if (chat.search_results[activeSearchResult + 1]) {
                    nextSearchResultId = activeSearchResult + 1
                }

                setSearchResult(nextSearchResultId)
            }
        }, {
            icon: 'angle-up',
            disableIfNoResults: true,
            onClick: () => {
                let nextSearchResultId = 0

                if (chat.search_results[activeSearchResult - 1]) {
                    nextSearchResultId = chat.search_results[activeSearchResult - 1]
                } else {
                    nextSearchResultId = chat.search_results.length - 1
                }

                setSearchResult(nextSearchResultId)
            }
        }, {
            icon: 'fe-x',
            onClick: () => {
                setSearchResult(null)
                toggleSearch()
            }
        }
    ]

    return (
        <div className={`dock-chat-search ${visible ? '' : 'hidden'}`}>
            <div className='input-wrap'>
                <Icon name={'fe-search'} />
                <InputStandard
                    outlineOnFocus={true}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    callback={handleSearch}
                    placeholder={`Search in this chat`}
                    innerRef={ref => inputRef.current = ref}
                />
            </div>
            <ul className='options'>
                {options.map(({
                    icon,
                    onClick,
                    disableIfNoResults
                }) => {
                    return (
                        <li key={icon}>
                            <button
                                disabled={!disableIfNoResults ? false : (!chatRef.current || !chatRef.current.search_results || !chatRef.current.search_results.length)}
                                onClick={onClick}
                            >
                                <Icon name={icon} />
                            </button>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        allChatResultResults: state.account.entities.chat_search_results,
        allChats: state.account.entities.chats
    }
}

export default connect(mapStateToProps, {
    searchChat,
})(DockChatSearch)


// WEBPACK FOOTER //
// ./src/layout/dock/dock-chat-search.jsx